export default __webpack_public_path__ + "static/media/task_active.d3a56d8b.svg";